define([
    "angular",
    "../sanitize/sanitize",
    "../form/form",
    "../number/number",
    "../time/time",
    "../nodeCommands/nodeCommands",
    "../violation/violation",
    "../filter/filter",
    "../maps/maps",
    "../hereMaps/hereMaps",
    "../nlgBasket/nlgBasket",
    "../nlgTemplate/nlgTemplate"
], function (angular) {
    "use strict";

    return angular.module("nlgAnalysisTreeModule", [
        "sanitizeModule",
        "entityDTOModule",
        "formModule",
        "numberModule",
        "timeModule",
        "nodeCommandsModule",
        "violationModule",
        "filterModule",
        "mapsModule",
        "hereMapsModule",
        "nlgBasketModule",
        "nlgTemplateModule"
    ]);
});